import { TranslateService } from '@ngx-translate/core';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DeviceSoftwareStatus } from '@nimmsta/ng-commons-lib/models';
import { parseEnumValue } from '@nimmsta/ng-commons-lib/utils/enum';

@Pipe({ name: 'toScannerSoftwareStatusBadge' })
export class ScannerSoftwareStatusPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(softwareStatus?: DeviceSoftwareStatus | null): string {
    const normalizedStatus = parseEnumValue(
      DeviceSoftwareStatus,
      softwareStatus,
      DeviceSoftwareStatus.MISSING_DATA,
    );
    if (!normalizedStatus) {
      return '-';
    }
    const statusKey = this.statusKeyFromSoftwareStatus(normalizedStatus);
    const translationGroup =
      normalizedStatus === DeviceSoftwareStatus.WARNING
        ? 'softwareStatusDetailValues'
        : 'softwareStatusValues';
    const text = this.translate.instant(
      `scanner.maintenance.${translationGroup}.${statusKey}`,
    );
    const badgeClass = this.badgeClassFromStatus(normalizedStatus);
    return `<div class="badge rounded-pill text-bg-light"><div class="dot ${badgeClass}"></div>${text}</div>`;
  }

  private badgeClassFromStatus(status: DeviceSoftwareStatus): string {
    if (status === DeviceSoftwareStatus.OK) {
      return 'active';
    }

    if (
      status === DeviceSoftwareStatus.WARNING ||
      status === DeviceSoftwareStatus.UPDATE_REQUESTED ||
      status === DeviceSoftwareStatus.IMAGER_FIRMWARE_UPDATE_REQUIRED
    ) {
      return 'needs-attention';
    }

    return 'inactive';
  }

  private statusKeyFromSoftwareStatus(status: DeviceSoftwareStatus): string {
    switch (status) {
      case DeviceSoftwareStatus.OK:
        return 'ok';
      case DeviceSoftwareStatus.WARNING:
        return 'warning';
      case DeviceSoftwareStatus.UPDATE_REQUESTED:
        return 'update_requested';
      case DeviceSoftwareStatus.IMAGER_FIRMWARE_UPDATE_REQUIRED:
        return 'imager_firmware_update_required';
      case DeviceSoftwareStatus.CUSTOM_FIRMWARE:
        return 'custom_firmware';
      case DeviceSoftwareStatus.MISSING_DATA:
        return 'missing_data';
    }
    const exhaustiveCheck: never = status;
    return exhaustiveCheck;
  }
}
